var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.items,"label":"Board Basis","item-text":"name","item-value":"name","outlined":_vm.outlined},on:{"change":function($event){return _vm.changeListener($event)}},model:{value:(_vm.selectedBoardBasis),callback:function ($$v) {_vm.selectedBoardBasis=$$v},expression:"selectedBoardBasis"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a89e742","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/BoardBasisListSelect.vue
// module id = null
// module chunks = 